<template>
    <div class="manual-external-checkout py-1">
        <v-alert v-if="alert" type="info" dense outlined text color="primary">
            <strong>تنبيه:</strong>
            {{ alert }}
        </v-alert>
        <div class="mb-4">
            <div class="manual-steps black--text text-center" style="font-size: 17px; line-height: 1.8rem; white-space: pre-line;" v-html="parseSteps(steps)"></div>
        </div>
        <v-btn @click="$emit('done', true)" color="primary" depressed block>
            <v-icon left>mdi-check</v-icon>
            <span>تم التحويل</span>
        </v-btn>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';

export default {
    props: {
        amount: {
            required: true,
        }
    },
    data(){
        return {
            loading: false,
            payerNumber: '',
            attachment: null,
            message: '',

            leaveMessage: false,

            rules: {
                required: value => !!value || 'لا يمكنك ترك الحقل فارغاً'
            },
        }
    },
    computed: {
        ...GlobalComputed,
        appRechargeInfo(){
            return this.appData ? this.appData.recharge_info : {};
        },
        steps(){
            return this.appRechargeInfo ? this.appRechargeInfo.manual_external_payments_instructions : '___';
        },
        alert(){
            return this.appRechargeInfo ? this.appRechargeInfo.manual_external_payments_alert : '___';
        },
    },
    methods: {
        ...GlobalMethods,
        
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system', validate: {email: value=>false}};
            return linkifyHtml(text, options);
        },
        parseSteps(text){
            let html = this.escapeHtmlText(text);
            html = text.replaceAll(/\*\*.*?\*\*?/ig, match=>{
                return `<strong class="steps-strong primary--text">${match.replaceAll('**', '')}</strong>`;
            });
            html = html.replaceAll('{AMOUNT}', `<strong class="amount-strong primary--text">${this.amount}</strong>`);

            html = this.urlify(html);
            return html
        },
    },
    mounted(){
        
    }
}
</script>

<style lang="scss">
.manual-external-checkout{
    .manual-steps{
        a{
            font-weight: bold;
        }
        .steps-strong, .amount-strong{
            padding: 2px 6px;
            border-radius: 8px;
        }
        .steps-strong{
            background: #eee;
        }
        .amount-strong{
            background: #eee;
            color: --var(--v-primary-base);
        }
    }
}
</style>